import { useState } from 'react'
import { ApiClient } from '../api'

// SignIn - public route at /auth/sign-in. Staff click through to the SWA
// AAD flow; volunteers enter an email and (when the magic-link backend is
// live) receive an email link. v1 the magic-link form posts to the stub
// endpoint that returns a "not wired yet" note.

export function SignIn() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [note, setNote] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim()) return
    setBusy(true)
    setError(null)
    try {
      const res = await ApiClient.requestMagicLink(email.trim())
      setSubmitted(true)
      if (res.note) setNote(res.note)
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#f5f1ea' }}>
      <div className="w-full max-w-md bg-white border border-line rounded-lg shadow-sm p-8 space-y-5">
        <div className="text-center">
          <div className="font-display text-3xl font-bold text-green">
            NYMR<span style={{ color: '#c9a13a' }}>.</span>
          </div>
          <div className="text-[11px] uppercase tracking-wider text-ink-soft font-semibold mt-1">
            Heritage Operations
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="font-display text-xl text-center">Sign in</h1>
        </div>

        <a
          href="/.auth/login/aad"
          className="block w-full py-2.5 rounded text-sm font-semibold text-center bg-green text-parchment hover:bg-green/90 transition-colors"
        >
          Staff sign-in (Microsoft)
        </a>

        <div className="text-center text-xs text-ink-soft">or volunteer sign-in</div>

        {submitted ? (
          <div className="space-y-3">
            <div
              className="rounded p-3 text-sm"
              style={{ background: '#dcebe5', color: '#0a4a3a' }}
            >
              If that email is registered, we've sent a sign-in link. Check
              your inbox.
            </div>
            {note && (
              <div className="rounded p-3 text-xs" style={{ background: '#f5edd5', color: '#9b7f2a' }}>
                {note}
              </div>
            )}
            <button
              type="button"
              onClick={() => { setSubmitted(false); setNote(null) }}
              className="text-xs text-green font-semibold hover:underline w-full text-center"
            >
              Send to a different address
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            <label className="block">
              <span className="text-xs uppercase tracking-wide font-semibold text-ink-soft block mb-1">
                Email address
              </span>
              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-line rounded px-3 py-2 text-sm bg-white focus:outline-none focus:border-green"
              />
            </label>
            <button
              type="submit"
              disabled={!email.trim() || busy}
              className="w-full py-2 rounded text-sm font-semibold border border-green text-green hover:bg-green hover:text-parchment transition-colors disabled:opacity-50"
            >
              {busy ? 'Sending…' : 'Send sign-in link'}
            </button>
            {error && (
              <p className="text-xs text-oxblood">{error}</p>
            )}
          </form>
        )}

        <p className="text-[11px] text-ink-soft text-center">
          By signing in you agree to NYMR's volunteer code of conduct.
        </p>
      </div>
    </div>
  )
}
